// extracted by mini-css-extract-plugin
export default {"btop":"c054b8829d f1cfec9675 _396506f2ad","icon":"cf5fc56139 _78662c19d4","btoppink":"_7f6e0fd193 bfdfc6c12e"};